import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyFormatter } from '@jms/model';

@Pipe({
    name: 'absCurrencyFormat',
    standalone: true
})
export class AbsCurrencyFormatPipe implements PipeTransform {

    constructor() { }

    public transform(value: number | string, round: string = '2'): string {

        let price = typeof value === 'number'
            ? value
            : Number(value)

        if (!price) {
            price = 0;
        }

        return CurrencyFormatter.formatCurrency(Math.abs(price), Number(round));
        // price = Math.abs(price);

        // const formattedNumber = this.decimalPipe.transform(price, `1.2-${round}`);
        // return ' $' + formattedNumber;

    }
}
